<template>
  <div v-if="!isScript">
    <div v-html="html"></div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapActions, mapState, mapMutations } from "vuex";
import flatpickr from "flatpickr";
import { LanguageMixin } from "../../views/Mixins/LanguageMixin";
export default {
  name: "WidgetComponent",
  props: ["html", "id", "action", "open"],
  data() {
    return {
      arr: [],
      numberAdditionName: "widgets[address][number_addition]",
      scriptArray: [],
    };
  },
  mixins: [LanguageMixin],
  methods: {
    ...mapActions({
      checkPostCode: "forms/checkPostCode",
      checkZiggo: "forms/checkZiggo",
      checkYoufone: "forms/checkYoufone",
      checkTmobile: "forms/checkTmobile",
      checkKpn: "forms/checkKpn",
      checkDisciplineCode: "forms/checkDisciplineCode",
      getMortgage: "forms/getMortgage",
    }),
    ...mapMutations({
      setAddressResidential: "forms/SET_ADDRESS_RESIDENTIAL",
    }),

    listError(arr) {
      if (Object.keys(arr).includes("error")) {
        if (
          Object.keys(arr.error).includes("en") &&
          Object.keys(arr.error).includes("nl")
        ) {
          this.arr.push(arr.error[this.lang]);
        }
      } else if (arr && typeof arr !== "string") {
        Object.keys(arr).forEach((key) => {
          this.listError(arr[key]);
        });
      } else if (arr && typeof arr === "string") {
        const value = arr === null ? "" : arr;
        this.arr.push(value);
      }
    },

    setNumberAdditionSubmit() {
      let actualElNumberAddition = $(`[name = "${this.numberAdditionName}"]`);
      if (this.numberAddition && !actualElNumberAddition.val()) {
        actualElNumberAddition.val(this.numberAddition);
        if (actualElNumberAddition[0]) {
          actualElNumberAddition[0].dispatchEvent(new Event("change"));
        }
      }
    },

    addScripts() {
      let body = document.getElementsByTagName("BODY")[0];
      if (this.html.includes("<script")) {
        var htmlArray = this.html.split("<script>");

        if (htmlArray.length > 0) {
          htmlArray.forEach((a) => {
            var script = this.htmlToScript(a);
            body.appendChild(script);
          });
        }
      }
    },

    htmlToScript(html) {
      this.propertyArray = html.split(/\s/);
      this.propertyArray = this.propertyArray.filter(
        (a) => !a.includes("<script")
      );
      this.propertyArray = this.propertyArray.map((a) =>
        a.replace(/><\/script>/g, "")
      );
      this.propertyArray = this.propertyArray.map((a) => a.slice(0, -1));
      this.propertyArray = this.propertyArray.map((a) => a.split('="'));

      let script = document.createElement("script");
      this.propertyArray.forEach((a) => {
        script.setAttribute(a[0], a[1]);
      });

      return script;
    },

    openModal(item) {
      this.open(item);
      // this.$emit("modal", {
      //   title: item.name[this.lang],
      //   description: item.description[this.lang],
      // });
    },

    calculateMortgage() {
      let first = document.getElementById("firstIncome")
        ? document.getElementById("firstIncome").value
        : "";
      let second = document.getElementById("secondIncome")
        ? document.getElementById("secondIncome").value
        : "";
      if (first !== "") {
        if (second === "") {
          second = 0;
        }
        this.getMortgage({ first: first, second: second }).then((res) => {
          if (res.data.data.error || res.data.error) {
            document.getElementById("max-mortgage").innerHTML =
              "Cannot Calculate";
            document.getElementById("brut-mortgage").style = "display:none";
            document.getElementById("mortgage-rente").style = "display:none";
            document.getElementById("mortgage-br").style = "display:none";
            if (this.overview.filter((x) => x.id === 58).length > 0) {
              this.overview.filter((x) => x.id === 58)[0].total = 0;
              this.overview.filter((x) => x.id === 58)[0].yearly = 0;
              this.overview.filter((x) => x.id === 58)[0].title = "Mortgage";
              this.overview.filter((x) => x.id === 58)[0].packages = [];
            }
          } else {
            this.handleMortgageWidget();
          }
        });
      }
    },

    handleMortgageWidget() {
      document.getElementById("brut-mortgage").style = "";
      document.getElementById("mortgage-rente").style = "";
      document.getElementById("mortgage-br").style = "";
      //max-mortgage
      document.getElementById("max-mortgage").innerHTML =
        "€ " + this.formatPrice(this.mortgage.max_mortgage);
      //brut-mortgage
      document.getElementById("brut-mortgage").innerHTML = this.formatPrice(
        this.mortgage.monthly_charge_gross
      );
      //rente-mortgage
      let a = document.getElementById("mortgage-rente").innerHTML;
      let b = a.replace("0%", this.mortgage.interest_rate + "%");
      document.getElementById("mortgage-rente").innerHTML = b;
      this.handleMortgageOverview();
    },

    handleMortgageOverview() {
      if (this.overview.filter((x) => x.id === 58).length > 0) {
        this.overview.filter((x) => x.id === 58)[0].total =
          this.mortgage.monthly_charge_gross;
        this.overview.filter((x) => x.id === 58)[0].yearly =
          this.mortgage.monthly_charge_gross * 12;
        this.overview.filter((x) => x.id === 58)[0].title = "Mortgage";
        this.overview.filter((x) => x.id === 58)[0].supplier.title = {
          en: "Mortgage Advice",
          nl: "Hypotheek Advies",
        };
        this.overview.filter((x) => x.id === 58)[0].packages = [
          {
            category_name: { en: "Max Mortgage", nl: "Max hypotheek" },
            name:
              '{"nl":"€ ' +
              this.formatPrice(this.mortgage.max_mortgage) +
              '","en":"€ ' +
              this.formatPrice(this.mortgage.max_mortgage) +
              '"}',
          },
          {
            category_name: { en: "Interest Rate", nl: "Rente" },
            name:
              '{"nl":"' +
              this.mortgage.interest_rate +
              '%","en":"' +
              this.mortgage.interest_rate +
              '%"}',
          },
          {
            category_name: {
              en: "Monthly Gross Charges",
              nl: "Bruto Maandlasten",
            },
            name:
              '{"nl":"€ ' +
              this.formatPrice(this.mortgage.monthly_charge_gross) +
              '","en":"€ ' +
              this.formatPrice(this.mortgage.monthly_charge_gross) +
              '"}',
          },
        ];
      }
    },
    clearMortage() {
      if (this.overview.filter((x) => x.id === 58).length > 0) {
        this.overview.filter((x) => x.id === 58)[0].total = 0;
        this.overview.filter((x) => x.id === 58)[0].yearly = 0;
        this.overview.filter((x) => x.id === 58)[0].title = "Mortgage";
        this.overview.filter((x) => x.id === 58)[0].packages = [];
      }
      document.getElementById("max-mortgage").innerHTML = "€ 0";
      document.getElementById("brut-mortgage").innerHTML = "0";
      let a = document.getElementById("mortgage-rente").innerHTML;
      let b = a.replace(this.mortgage.interest_rate + "%", "0%");
      document.getElementById("mortgage-rente").innerHTML = b;
    },
    setCustomCss() {
      Object.keys(this.form.data.attributes).map((a) => {
        if (this.form.data.attributes[a].isTag) {
          let cssAttributes =
            this.form.data.attributes[a].attributes.split("\n");
          cssAttributes.map((x) => {
            let attribute = x.split(":")[0];
            let value = x.split(":")[1];
            $(a).css(`${attribute}`, value);
          });
        } else {
          let className = a.replace("_", "-");
          let cssAttributes =
            this.form.data.attributes[a].attributes.split("\n");
          cssAttributes.map((x) => {
            let attribute = x.split(":")[0];
            let value = x.split(":")[1];
            $(`.${className}`).css(`${attribute}`, value);
          });
        }
      });
    },
  },
  watch: {
    selectedProducts() {
      //for Mortgage Advice
      if (this.selectedProducts.includes(58)) {
        this.calculateMortgage();
      }
    },
    lang() {
      if (document.getElementById("mortgage-rente")) {
        let a = document.getElementById("mortgage-rente").innerHTML;
        let b = a.replace(
          "%s",
          this.mortgage.interest_rate ? this.mortgage.interest_rate + "%" : "0%"
        );
        document.getElementById("mortgage-rente").innerHTML = b;
      }
    },
    postcodeQuery(val) {
      if (val !== null) {
        // if(val.gebruiksdoelen === 1){
        //   $("#kvk").parent().hide()
        //   $("#bedrijfsnaam").parent().hide()
        // }else{
        //   $("#kvk").parent().show()
        //   $("#bedrijfsnaam").parent().show()
        // }
        if (val.error) {
          this.$store.commit("forms/CLEAR_INTERNET_OVERVİEW");
        }
        if (val.gebruiksdoelen) {
          this.form.data.customertype = val.gebruiksdoelen;
        }
      }
    },
  },
  computed: {
    ...mapState({
      combinations: (state) => state.forms.combinations,
      nationalities: (state) => state.forms.nationalities,
      itemsIsShow: (state) => state.forms.itemIsShow,
      numberAddition: (state) => state.forms.postcode.numberAddition,
      mortgage: (state) => state.forms.mortgage,
      addressResidential: (state) => state.forms.addressResidential
    }),
    isScript() {
      return this.html.includes("<script");
    },
  },
  mounted() {
    this.addScripts();
    let vueThis = this;
    vueThis.makeTranslate(this.lang);
    let d = new Date();

    flatpickr(".dateinput", {
      dateFormat: "d-m-Y",
    });

    if ($("#adress")) {
      $("#adressOfClick").html(
        "<i style='color: #0665d0' class='fas fa-info-circle fa'></i>"
      );
    }

    $("#adressOfClick").on("click", function () {
      let item = {
        name: {
          en: "",
          nl: "",
        },
        description: {
          en: vueThis.translate["en"]["adressdesc1"],
          nl: vueThis.translate["nl"]["adressdesc1"],
        },
      };
      vueThis.openModal(item);
      window.$("#computedInfo").modal();
    });

    if (vueThis.isLead) {
      $("#adress").parent().hide();
    } else {
      $("#adress").parent().show();
    }

    $("#adress").on("click", function () {
      vueThis.setAddressResidential(this.checked);

    });

    if (this.customertype == 2) {
      $("#kvk").parent().show();
      $("#bedrijfsnaam").parent().show();
    } else {
      $("#kvk").parent().hide();
      $("#bedrijfsnaam").parent().hide();
    }

    flatpickr("#date_of_birth", {
      dateFormat: "d-m-Y",
      maxDate: new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1),
      allowInput: true,
    });

    $(document).on("change", function () {
      if (vueThis.form.data.attributes) {
        vueThis.setCustomCss();
      }
    });

    if ($("#example-checkbox-inline17")) {
      $("#example-checkbox-inline17").attr("checked", true);
    }

    $("#mortgage-advice-modal").click(function () {
      let item = vueThis.products.filter((x) => x.group === "mortgage")[0] || {
        description: "",
        name: "",
      };
      vueThis.openModal(item);
    });

    if (document.getElementById("mortgage-rente")) {
      let a = document.getElementById("mortgage-rente").innerHTML;
      let b = a.replace("%s", "0%");
      document.getElementById("mortgage-rente").innerHTML = b;
    }

    $("#mortgageCalculate").click(function () {
      vueThis.calculateMortgage();
    });

    $("#firstIncome, #secondIncome").change(function () {
      if ($("#firstIncome").val() !== "") {
        vueThis.calculateMortgage();
      } else {
        vueThis.clearMortage();
      }
    });

    $("#date_of_birth, .dateinput, .flatpickr-input").attr(
      "autocomplete",
      "off"
    );
    $("#date_of_birth").change(function () {
      $("#date-of-birth-alert").remove();
    });

    $("#date_of_birth").keyup(function (e) {
      // backspace key code => 8(number)
      if (e.keyCode === 8) {
        return;
      } else if (this.value.length >= 11) {
        let value = this.value;
        this.value = value.slice(0, 10);
      } else {
        if (this.value.length === 2) {
          let value = this.value;
          this.value = value + "-";
        } else if (this.value.length === 3 && this.value[2] !== "-") {
          let value = this.value;
          this.value = value[0] + value[1] + "-" + value[2];
        } else if (this.value.length === 5) {
          let value = this.value;
          this.value = value + "-";
        } else if (this.value.length === 6 && this.value[5] !== "-") {
          let value = this.value;
          this.value =
            value[0] +
            value[1] +
            value[2] +
            value[3] +
            value[4] +
            "-" +
            value[5];
        }
      }
    });

    $("#expireat, #issuedat").change(function () {
      $("#expireat-alert").remove();
      let expire = $("#expireat").val();
      let issued = $("#issuedat").val();
      let exDate = new Date(
        expire.split("-")[1] +
          "/" +
          expire.split("-")[0] +
          "/" +
          expire.split("-")[2]
      );
      let issueDate = new Date(
        issued.split("-")[1] +
          "/" +
          issued.split("-")[0] +
          "/" +
          issued.split("-")[2]
      );
      $("#expire1-alert").remove();
      $("#expire-alert").remove();
      $("#issued-alert").remove();
      if ($("#expireat").val() === "") {
        $("#expireat")
          .parent()
          .append(
            '<div  id="expire1-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="expireat-2">' +
              vueThis.translate[vueThis.lang]["expireat-2"] +
              "</p></div></div>"
          );
      } else if ($("#issuedat").val() === "") {
        $("#expireat")
          .parent()
          .append(
            '<div id="issued-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="issuedat-1">' +
              vueThis.translate[vueThis.lang]["issuedat-1"] +
              "</p></div></div>"
          );
      } else if (exDate.getTime() < issueDate.getTime()) {
        $("#expire-alert").remove();
        $("#expireat")
          .parent()
          .append(
            '<div id="expire-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="expireat-1">' +
              vueThis.translate[vueThis.lang]["expireat-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });

    $("#meter_kwh").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_kwh").val() === "") {
        $("#meter_kwh").removeClass("alert-danger");
        $("#meter_kwh-alert").remove();
      } else if (test.test($("#meter_kwh").val())) {
        $("#meter_kwh").removeClass("alert-danger");
        $("#meter_kwh-alert").remove();
      } else {
        $("#meter_kwh").addClass("alert-danger");
        $("#meter_kwh-alert").remove();
        $("#meter_kwh")
          .parent()
          .append(
            '<div  id="meter_kwh-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meterkwh">' +
              vueThis.translate[vueThis.lang]["meterkwh"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#meter_number1").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_number1").val() === "") {
        $("#meter_number1").removeClass("alert-danger");
        $("#meter_number1-alert").remove();
      } else if (test.test($("#meter_number1").val())) {
        $("#meter_number1").removeClass("alert-danger");
        $("#meter_number1-alert").remove();
      } else {
        $("#meter_number1").addClass("alert-danger");
        $("#meter_number1-alert").remove();
        $("#meter_number1")
          .parent()
          .append(
            '<div id="meter_number1-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meter">' +
              vueThis.translate[vueThis.lang]["meter"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#meter_m3").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_m3").val() === "") {
        $("#meter_m3").removeClass("alert-danger");
        $("#meter_m3-alert").remove();
      } else if (test.test($("#meter_m3").val())) {
        $("#meter_m3").removeClass("alert-danger");
        $("#meter_m3-alert").remove();
      } else {
        $("#meter_m3").addClass("alert-danger");
        $("#meter_m3-alert").remove();
        $("#meter_m3")
          .parent()

          .append(
            '<div  id="meter_m3-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meter_m3-1">' +
              vueThis.translate[vueThis.lang]["meter_m3-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#meter_number").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_number").val() === "") {
        $("#meter_number").removeClass("alert-danger");
        $("#meter_number-alert").remove();
      } else if (test.test($("#meter_number").val())) {
        $("#meter_number").removeClass("alert-danger");
        $("#meter_number-alert").remove();
      } else {
        $("#meter_number").addClass("alert-danger");
        $("#meter_number-alert").remove();
        $("#meter_number")
          .parent()
          .append(
            '<div id="meter_number-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meter-water">' +
              vueThis.translate[vueThis.lang]["meter-water"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#water_m3").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#water_m3").val() === "") {
        $("#water_m3").removeClass("alert-danger");
        $("#water_m3-alert").remove();
      } else if (test.test($("#water_m3").val())) {
        $("#water_m3").removeClass("alert-danger");
        $("#water_m3-alert").remove();
      } else {
        $("#water_m3").addClass("alert-danger");
        $("#water_m3-alert").remove();
        $("#water_m3")
          .parent()
          .append(
            '<div id="water_m3-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="water_m3-1">' +
              vueThis.translate[vueThis.lang]["water_m3-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#meter_number_heating").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_number_heating").val() === "") {
        $("#meter_number_heating").removeClass("alert-danger");
        $("#meter_number_heating-alert").remove();
      } else if (test.test($("#meter_number_heating").val())) {
        $("#meter_number_heating").removeClass("alert-danger");
        $("#meter_number_heating-alert").remove();
      } else {
        $("#meter_number_heating").addClass("alert-danger");
        $("#meter_number_heating-alert").remove();
        $("#meter_number_heating")
          .parent()
          .append(
            '<div id="meter_number_heating-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meter-heating">' +
              vueThis.translate[vueThis.lang]["meter-heating"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#meter_m3_heatig").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_m3_heatig").val() === "") {
        $("#meter_m3_heatig").removeClass("alert-danger");
        $("#meter_m3_heatig-alert").remove();
      } else if (test.test($("#meter_m3_heatig").val())) {
        $("#meter_m3_heatig").removeClass("alert-danger");
        $("#meter_m3_heatig-alert").remove();
      } else {
        $("#meter_m3_heatig").addClass("alert-danger");
        $("#meter_m3_heatig-alert").remove();
        $("#meter_m3_heatig")
          .parent()
          .append(
            '<div id="meter_m3_heatig-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meter_m3_heatig-1">' +
              vueThis.translate[vueThis.lang]["meter_m3_heatig-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#meter_m3_heating").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_m3_heating").val() === "") {
        $("#meter_m3_heating").removeClass("alert-danger");
        $("#meter_m3_heating-alert").remove();
      } else if (test.test($("#meter_m3_heating").val())) {
        $("#meter_m3_heating").removeClass("alert-danger");
        $("#meter_m3_heating-alert").remove();
      } else {
        $("#meter_m3_heating").addClass("alert-danger");
        $("#meter_m3_heating-alert").remove();
        $("#meter_m3_heating")
          .parent()
          .append(
            '<div id="meter_m3_heating-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meter_m3_heating-1">' +
              vueThis.translate[vueThis.lang]["meter_m3_heating-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#meter_m3_gas").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_m3_gas").val() === "") {
        $("#meter_m3_gas").removeClass("alert-danger");
        $("#meter_m3_gas-alert").remove();
      } else if (test.test($("#meter_m3_gas").val())) {
        $("#meter_m3_gas").removeClass("alert-danger");
        $("#meter_m3_gas-alert").remove();
      } else {
        $("#meter_m3_gas").addClass("alert-danger");
        $("#meter_m3_gas-alert").remove();
        $("#meter_m3_gas")
          .parent()
          .append(
            '<div id="meter_m3_gas-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meter_m3_gas-1">' +
              vueThis.translate[vueThis.lang]["meter_m3_gas-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#meter_number_gas").on("keyup change", function () {
      var test = /^([0-9][0-9]*)$/;
      if ($("#meter_number_gas").val() === "") {
        $("#meter_number_gas").removeClass("alert-danger");
        $("#meter_number_gas-alert").remove();
      } else if (test.test($("#meter_number_gas").val())) {
        $("#meter_number_gas").removeClass("alert-danger");
        $("#meter_number_gas-alert").remove();
      } else {
        $("#meter_number_gas").addClass("alert-danger");
        $("#meter_number_gas-alert").remove();
        $("#meter_number_gas")
          .parent()
          .append(
            '<div  id="meter_number_gas-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="meter_number_gas-1">' +
              vueThis.translate[vueThis.lang]["meter_number_gas-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#email").on("keyup change", function () {
      // var test = new RegExp(
      //   '^(([^<>()[].,;:s@"]+(.[^<>()[].,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$'
      // );
      var test =
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (test.test($("#email").val())) {
        $("#email").removeClass("alert-danger");
        $("#email-alert").remove();
      } else {
        $("#email").addClass("alert-danger");
        $("#email-alert").remove();
        $("#email")
          .parent()
          .append(
            '<div id="email-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="email-1">' +
              vueThis.translate[vueThis.lang]["email-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });

    $("#emaillead").on("keyup change", function () {
      var test =
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (test.test($("#emaillead").val())) {
        $("#emaillead").removeClass("alert-danger");
        $("#emaillead-alert").remove();
      } else {
        $("#emaillead").addClass("alert-danger");
        $("#emaillead-alert").remove();
        $("#emaillead")
          .parent()
          .append(
            '<div id="emaillead-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="email-1">' +
              vueThis.translate[vueThis.lang]["email-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#identificationnumber").on("keyup change", function () {
      var test = /^[0-9]*$/;
      var test2 = /^([0-9][0-9]*){3,214}$/;
      if ($("#identificationnumber").val() === "") {
        $("#identificationnumber").removeClass("alert-danger");
        $("#identificationnumber-alert").remove();
        $("#identificationnumber-alert-1").remove();
      } else if (test.test($("#identificationnumber").val())) {
        $("#identificationnumber").removeClass("alert-danger");
        $("#identificationnumber-alert").remove();
        $("#identificationnumber-alert-1").remove();

        if (test2.test($("#identificationnumber").val())) {
          $("#identificationnumber").removeClass("alert-danger");
          $("#identificationnumber-alert").remove();
          $("#identificationnumber-alert-1").remove();
        } else if (!test2.test($("#identificationnumber").val())) {
          $("#identificationnumber").addClass("alert-danger");
          $("#identificationnumber-alert").remove();
          $("#identificationnumber-alert-1").remove();
          $("#identificationnumber")
            .parent()
            .append(
              '<div id="identificationnumber-alert-1"><div class="alert alert-danger" role="alert"><p class="mb-0" id="mustbenumber-1">' +
                vueThis.translate[vueThis.lang]["mustbenumber-1"] +
                "" +
                "</p></div></div>"
            );
        }
      } else if (!test.test($("#identificationnumber").val())) {
        $("#identificationnumber").addClass("alert-danger");
        $("#identificationnumber-alert").remove();
        $("#identificationnumber-alert-1").remove();
        $("#identificationnumber")
          .parent()
          .append(
            '<div  id="identificationnumber-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="mustbenumber">' +
              vueThis.translate[vueThis.lang]["mustbenumber"] +
              "" +
              "</p></div></div>"
          );
      }
    });

    $("#phone-6").on("keyup change", function () {
      var test =
        /^[+]*[0-9]*[ ]{0,1}[(]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[)]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[-]{0,1}[ ]{0,1}[0-9]{1,5}$/;
      if (test.test($("#phone-6").val())) {
        $("#phone-6").removeClass("alert-danger");
        $("#phone-alert").remove();
      } else {
        $("#phone-6").addClass("alert-danger");
        $("#phone-alert").remove();
        $("#phone-6")
          .parent()
          .append(
            '<div id="phone-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="phone-1">' +
              vueThis.translate[vueThis.lang]["phone-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#phonelead").on("keyup change", function () {
      var test =
        /^[+]*[0-9]*[ ]{0,1}[(]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[)]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[-]{0,1}[ ]{0,1}[0-9]{1,5}$/;
      if (test.test($("#phonelead").val())) {
        $("#phonelead").removeClass("alert-danger");
        $("#phonelead-alert").remove();
      } else {
        $("#phonelead").addClass("alert-danger");
        $("#phonelead-alert").remove();
        $("#phonelead")
          .parent()
          .append(
            '<div id="phonelead-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="phone-lead">' +
              vueThis.translate[vueThis.lang]["phone-lead"] +
              "" +
              "</p></div></div>"
          );
      }
    });

    $("#phone3").on("keyup change", function () {
      var test =
        /^[+]*[0-9]*[ ]{0,1}[(]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[)]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[-]{0,1}[ ]{0,1}[0-9]{1,5}$/;
      if (
        $("#phone3").val() === "" ||
        $("#phone3").val() === null ||
        $("#phone3").val() === undefined
      ) {
        $("#phone3").removeClass("alert-danger");
        $("#phone3-alert").remove();
      } else if (test.test($("#phone3").val())) {
        $("#phone3").removeClass("alert-danger");
        $("#phone3-alert").remove();
      } else {
        $("#phone3").addClass("alert-danger");
        $("#phone3-alert").remove();
        $("#phone3")
          .parent()
          .append(
            '<div  id="phone3-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="phone-3">' +
              vueThis.translate[vueThis.lang]["phone-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });

    $("#phone2").on("keyup change", function () {
      var test =
        /^[+]*[0-9]*[ ]{0,1}[(]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[)]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[-]{0,1}[ ]{0,1}[0-9]{1,5}$/;
      if ($("#phone2").val() === "") {
        $("#phone2").removeClass("alert-danger");
        $("#phone2-alert").remove();
      } else if (test.test($("#phone2").val())) {
        $("#phone2").removeClass("alert-danger");
        $("#phone2-alert").remove();
      } else {
        $("#phone2").addClass("alert-danger");
        $("#phone2-alert").remove();
        $("#phone2")
          .parent()
          .append(
            '<div id="phone2-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="phone-1">' +
              vueThis.translate[vueThis.lang]["phone-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#number_retention").change(function () {
      var test =
        /^[+]*[0-9]*[ ]{0,1}[(]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[)]{0,1}[ ]{0,1}[0-9]{1,3}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[-]{0,1}[ ]{0,1}[0-9]{1,5}$/;

      if ($("#phone3-alert")[0] && !$("#number_retention")[0].checked) {
        $("#phone3").removeClass("alert-danger");
        $("#phone3-alert").remove();
      } else if ($("#phone3").val() === "") {
        $("#phone3").removeClass("alert-danger");
        $("#phone3-alert").remove();
      } else if (!test.test($("#phone3").val())) {
        $("#phone3").addClass("alert-danger");
        $("#phone3-alert").remove();
        $("#phone3")
          .parent()
          .parent()
          .append(
            '<div class="col-md-12 " id="phone3-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="phone-3">' +
              vueThis.translate[vueThis.lang]["phone-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });

    $("#iban").on("keyup change", function () {
      let value = $("#iban").val();
      this.value = value.toUpperCase();
      var test =
        /^AL\d{10}[0-9A-Z]{16}$|^AD\d{10}[0-9A-Z]{12}$|^AT\d{18}$|^EG\d{27}$|^BH\d{2}[A-Z]{4}[0-9A-Z]{14}$|^BE\d{14}$|^BA\d{18}$|^BG\d{2}[A-Z]{4}\d{6}[0-9A-Z]{8}$|^HR\d{19}$|^CY\d{10}[0-9A-Z]{16}$|^IQ\d{2}[A-Z]{4}[0-9A-Z]{15}$|^JO\d{2}[A-Z]{4}[0-9A-Z]{22}$|^PK\d{2}[A-Z]{4}[0-9A-Z]{16}$|^CZ\d{22}$|^DK\d{16}$|^FO\d{16}$|^GL\d{16}$|^DO\d{2}[0-9A-Z]{4}\d{20}$|^EE\d{18}$|^FI\d{16}$|^FR\d{12}[0-9A-Z]{11}\d{2}$|^GE\d{2}[A-Z]{2}\d{16}$|^DE\d{20}$|^GI\d{2}[A-Z]{4}[0-9A-Z]{15}$|^GR\d{9}[0-9A-Z]{16}$|^HU\d{26}$|^IS\d{24}$|^IE\d{2}[A-Z]{4}\d{14}$|^IL\d{21}$|^IT\d{2}[A-Z]\d{10}[0-9A-Z]{12}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$|^KW\d{2}[A-Z]{4}22!$|^LV\d{2}[A-Z]{4}[0-9A-Z]{13}$|^LB\d{6}[0-9A-Z]{20}$|^LI\d{7}[0-9A-Z]{12}$|^LT\d{18}$|^LU\d{5}[0-9A-Z]{13}$|^MK\d{5}[0-9A-Z]{10}\d{2}$|^MT\d{2}[A-Z]{4}\d{5}[0-9A-Z]{18}$|^MR13\d{23}$|^MU\d{2}[A-Z]{4}\d{19}[A-Z]{3}$|^MC\d{12}[0-9A-Z]{11}\d{2}$|^ME\d{20}$|^NL\d{2}[A-Z]{4}\d{10}$|^NO\d{13}$|^PL\d{26}$|^PT\d{23}$|^RO\d{2}[A-Z]{4}[0-9A-Z]{16}$|^AZ\d{2}[A-Z]{4}[0-9A-Z]{20}$|^KW\d{2}[A-Z]{4}[0-9A-Z]{22}$|^QA\d{2}[A-Z]{4}[0-9A-Z]{21}$|^PS\d{2}[A-Z]{4}[0-9A-Z]{21}$|^BY\d{2}[A-Z]{4}[0-9A-Z]{20}$|BR\d{25}[A-Z]{1}[A-Z0-9]{1}|^SM\d{2}[A-Z]\d{10}[0-9A-Z]{12}$|^SA\d{4}[0-9A-Z]{18}$|^RS\d{20}$|^SK\d{22}$|^SI\d{17}$|^ES\d{22}$|^SE\d{22}$|^CH\d{7}[0-9A-Z]{12}$|^TN59\d{20}$|^TR\d{7}[0-9A-Z]{17}$|^UA\d{8}[A-Z0-9]{19}$|^PL\d{7}[0-9A-Z]{26}$|^AE\d{21}$|^GB\d{2}[A-Z]{4}\d{14}$/;
      if (test.test($("#iban").val())) {
        $("#iban").removeClass("alert-danger");
        $("#iban-alert").remove();
      } else {
        $("#iban").addClass("alert-danger");
        $("#iban-alert").remove();
        $("#iban")
          .parent()
          .append(
            '<div id="iban-alert"><div class="alert alert-danger" role="alert"><p class="mb-0" id="iban-1">' +
              vueThis.translate[vueThis.lang]["iban-1"] +
              "" +
              "</p></div></div>"
          );
      }
    });
    $("#legitimation_type").change(function () {
      $("#legitimation_type-alert").remove();
    });

    $("#betaalwijze_ai").prop("checked", "true");

    //$("#switching_id").prop("checked", "false");
    //$("#moving_id").prop("checked", "true");

    $("#language_id").prop("checked", "true");

    $("#nationality").change(function () {
      $("#nationality-alert").remove();
    });

    if ($("#nationality").length > 0) {
      let nationalites =
        "<option selected disabled>" +
        this.translate[this.lang]["choise"] +
        "</option>";

      vueThis.nationalities.forEach((x) => {
        nationalites += '<option value="' + x.id + '">' + x.name + "</option>";
      });
      $("#nationality").html(nationalites);

      if ($("#legitimation_type").length > 0) {
        $("#legitimation_type")
          .children()
          .each(function () {
            if (
              $(this).attr("value") === "id" ||
              $(this).attr("value") === "rijbewijs"
            ) {
              $(this).hide();
            }
          });

        $("#nationality").change(function () {
          $("#legitimation_type").val("");
          if (
            parseInt($(this).val()) === 404 ||
            parseInt($(this).val()) === 166
          ) {
            $("#legitimation_type")
              .children()
              .each(function () {
                if (
                  $(this).attr("value") === "id" ||
                  $(this).attr("value") === "rijbewijs"
                ) {
                  $(this).show();
                }
              });
          } else {
            $("#legitimation_type")
              .children()
              .each(function () {
                if (
                  $(this).attr("value") === "id" ||
                  $(this).attr("value") === "rijbewijs"
                ) {
                  $(this).hide();
                }
              });
          }
        });
      }
    }

    if ($("#number_retention").length > 0) {
      $("#number_retention").change(function () {
        if ($(this).is(":checked")) {
          $(".keep").removeClass("hidden");
          $('input[name ="widgets[mobile][number_retention][phone]"]').attr(
            "required",
            "required"
          );
        } else {
          $(".keep").addClass("hidden");
          $(".abonment").addClass("hidden");
          $("#number_retention_type").val("");
          $(
            'input[name ="widgets[mobile][number_retention][phone]"]'
          ).removeAttr("required");
        }
      });
    }

    if ($("#number_retention_type").length > 0) {
      $("#number_retention_type").change(function () {
        if ($(this).val() === "abonnement") {
          $(".abonment").removeClass("hidden");
        } else {
          $(".abonment").addClass("hidden");
        }
      });
    }

    $("#number_addition").change(function () {
      if ($(this).val() !== null) {
        $("#postcode").parent().parent().find(".alert-danger").remove();
      }
    });
    if (this.action === "postcode") {
      $("#housenumber, #postcode").change(function () {
        $("#number_addition").val(null);
      });
    }

    if (this.action === "postcode") {
      $("#housenumber, #number_addition, #postcode").change(async (event) => {
        $("#addressBlock").find(".alert-danger").remove();
        vueThis.$store.commit("forms/CLEAR_ITEM_SHOW");
        //vueThis.$store.commit("forms/CLEAR_INTERNET_SERVICES");
        vueThis.$store.commit("forms/CLEAR_INTERNET_OVERVİEW");
        vueThis.$store.commit("forms/CLEAR_DISCIPLINECODE");
        vueThis.$store.commit("forms/SET_POSTCODE", null);
        let postcode = $("#postcode").val();
        let housenumber = $("#housenumber").val();
        let houseNumberAddition = $("#number_addition").val();
        let providers = [];
        $("#street").val("");
        $("#street").attr("readonly", false);
        $("#city").val("");
        $("#city").attr("readonly", false);
        if (postcode && housenumber) {
          // Postcode : 8442DJ HouseNumber : 73
          await vueThis
            .checkPostCode({ postcode: postcode, housenumber: housenumber })
            .then((res) => {
              if (res.data && !res.data.error) {
                if (
                  res.data.latitude &&
                  res.data.longitude &&
                  !vueThis.isLead
                ) {
                  vueThis.checkDisciplineCode({
                    latitude: res.data.latitude,
                    longitude: res.data.longitude,
                  });
                }
                if (
                  res.data.houseNumberAdditions.length > 1 &&
                  houseNumberAddition === null
                ) {
                  vueThis.$store.commit("forms/SET_POSTCODE", null);
                }
                if (res.data && res.data.houseNumberAdditions.length > 1) {
                  $("#postcode").removeClass("alert-danger");
                  $("#housenumber").removeClass("alert-danger");
                  $("#postcode")
                    .parent()
                    .parent()
                    .find(".alert-danger")
                    .remove();
                  $("#number_addition").parent().parent().show();
                  $("#postcode").parent().removeClass("col-sm-6");
                  $("#housenumber").parent().removeClass("col-sm-6");
                  $("#postcode").parent().addClass("col-sm-4");
                  $("#housenumber").parent().addClass("col-sm-4");
                  if ($("#number_addition").val() === null) {
                    $("#postcode")
                      .parent()
                      .parent()
                      .append(
                        '<div class="col-md-12 "><div class="alert alert-danger" role="alert"><p class="mb-0">' +
                          vueThis.translate[vueThis.lang]["choisealert"] +
                          "</p></div></div>"
                      );
                  }
                } else {
                  //$("#city-street-row").removeClass("row");
                  $("#postcode").removeClass("alert-danger");
                  $("#housenumber").removeClass("alert-danger");
                  $("#number_addition").parent().parent().hide();
                  $("#postcode").parent().removeClass("col-sm-4");
                  $("#housenumber").parent().removeClass("col-sm-4");
                  $("#postcode").parent().addClass("col-sm-6");
                  $("#housenumber").parent().addClass("col-sm-6");
                  $("#postcode")
                    .parent()
                    .parent()
                    .find(".alert-danger")
                    .remove();
                }
                if (
                  ($(event.target).attr("id") === "housenumber" ||
                    $(event.target).attr("id") === "postcode") &&
                  res.data
                ) {
                  let numberAddition =
                    "<option selected required disabled>" +
                    vueThis.translate[vueThis.lang]["choise"] +
                    "</option>";
                  if (res.data.houseNumberAdditions) {
                    res.data.houseNumberAdditions.forEach((x) => {
                      if (x === "") {
                        numberAddition +=
                          '<option value="' + "" + '">' + x + "</option>";
                      } else {
                        numberAddition +=
                          '<option value="' + x + '">' + x + "</option>";
                      }
                    });
                  }
                  // houseNumberAddition = 'no';
                  $("#number_addition").html(numberAddition);
                }

                vueThis.setNumberAdditionSubmit();

                $("#street").val(res.data.street);
                $("#street").attr("readonly", true);
                $("#city").val(res.data.city);
                $("#city").attr("readonly", true);
                Object.values(
                  vueThis.$store.state.forms.formStateData.data.fields.filter(
                    (x) => x.length > 0
                  )
                ).forEach((itemParent) => {
                  let checkSupplier = itemParent.filter(
                    (x) => x.type === "suppliers"
                  );
                  if (
                    checkSupplier.length > 0 &&
                    vueThis.combinations[checkSupplier[0].group] &&
                    vueThis.combinations[checkSupplier[0].group]
                      .supplierCheck &&
                    vueThis.postcodeQuery
                  ) {
                    checkSupplier[0].speed = [];
                    checkSupplier[0].groupDefault =
                      checkSupplier[0].groupDefaultOld !==
                      checkSupplier[0].groupDefault
                        ? checkSupplier[0].groupDefaultOld
                        : checkSupplier[0].groupDefault;
                    providers = vueThis.uniqueArray(
                      checkSupplier[0].suppliers,
                      "title"
                    );
                    providers.forEach((item) => {
                      item.available = 1;
                      let defaultSupplier = vueThis.defaultSupplier("internet");
                      /*Youfone*/
                      if (item.supplier_id === 57) {
                        vueThis
                          .checkYoufone({
                            postcode: postcode,
                            housenumber: housenumber,
                            houseNumberAddition:
                              houseNumberAddition === null
                                ? ""
                                : houseNumberAddition,
                          })
                          .then((res) => {
                            if (
                              typeof res.data !== undefined &&
                              !res.data.data.speed
                            ) {
                              item.available = 1;
                              if (
                                defaultSupplier &&
                                defaultSupplier.supplier_id ===
                                  res.data.data.supplier_id
                              ) {
                                vueThis.$store.commit(
                                  "forms/DELETE_OVERVIEW_ELEMENT"
                                );
                              }

                              if (
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).length == 0
                              ) {
                                vueThis.$store.state.forms.itemIsShow.push({
                                  id: item.supplier_id,
                                  isShow: false,
                                });
                              } else {
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).isShow = false;
                              }
                            } else {
                              item.available = 0;
                              if (
                                defaultSupplier &&
                                defaultSupplier.supplier_id ===
                                  res.data.data.supplier_id
                              ) {
                                vueThis.setOverview();
                              }
                              if (
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).length == 0
                              ) {
                                vueThis.$store.state.forms.itemIsShow.push({
                                  id: item.supplier_id,
                                  isShow: true,
                                });
                              } else {
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).isShow = true;
                              }
                            }
                          });
                      }
                      /*Kpn*/
                      if (item.supplier_id === 3) {
                        vueThis
                          .checkKpn({
                            postcode: postcode,
                            housenumber: housenumber,
                            houseNumberAddition:
                              houseNumberAddition === null
                                ? ""
                                : houseNumberAddition,
                          })
                          .then((res) => {
                            if (
                              typeof res.data !== undefined &&
                              !res.data.data.speed
                            ) {
                              item.available = 1;

                              if (
                                defaultSupplier &&
                                defaultSupplier.supplier_id ===
                                  res.data.data.supplier_id
                              ) {
                                vueThis.$store.commit(
                                  "forms/DELETE_OVERVIEW_ELEMENT"
                                );
                              }

                              if (
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).length == 0
                              ) {
                                vueThis.$store.state.forms.itemIsShow.push({
                                  id: item.supplier_id,
                                  isShow: false,
                                });
                              } else {
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).isShow = false;
                              }
                              // checkSupplier[0].groupDefault = providers.filter(
                              //   x => x.available === 0
                              // )[0].supplier_id;
                            } else {
                              item.available = 0;
                              if (
                                defaultSupplier &&
                                defaultSupplier.supplier_id ===
                                  res.data.data.supplier_id
                              ) {
                                vueThis.setOverview();
                              }
                              if (
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).length == 0
                              ) {
                                vueThis.$store.state.forms.itemIsShow.push({
                                  id: item.supplier_id,
                                  isShow: true,
                                });
                              } else {
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).isShow = true;
                              }
                            }
                          });
                      }
                      /*tmobile*/
                      if (item.supplier_id === 11) {
                        vueThis
                          .checkTmobile({
                            postcode: postcode,
                            housenumber: housenumber,
                            houseNumberAddition:
                              houseNumberAddition === null
                                ? ""
                                : houseNumberAddition,
                          })
                          .then((res) => {
                            if (
                              typeof res.data !== undefined &&
                              !res.data.data.speed
                            ) {
                              item.available = 1;

                              if (
                                defaultSupplier &&
                                defaultSupplier.supplier_id ===
                                  res.data.data.supplier_id
                              ) {
                                vueThis.$store.commit(
                                  "forms/DELETE_OVERVIEW_ELEMENT"
                                );
                              }
                              if (
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).length == 0
                              ) {
                                vueThis.$store.state.forms.itemIsShow.push({
                                  id: item.supplier_id,
                                  isShow: false,
                                });
                              } else {
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).isShow = false;
                              }
                            } else {
                              item.available = 0;
                              if (
                                defaultSupplier &&
                                defaultSupplier.supplier_id ===
                                  res.data.data.supplier_id
                              ) {
                                vueThis.setOverview();
                              }
                              if (
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).length == 0
                              ) {
                                vueThis.$store.state.forms.itemIsShow.push({
                                  id: item.supplier_id,
                                  isShow: true,
                                });
                              } else {
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).isShow = true;
                              }
                            }
                          });
                      }
                      /*Vodafone Ziggo*/
                      if (item.supplier_id === 1) {
                        vueThis
                          .checkZiggo({
                            postcode: postcode,
                            housenumber: housenumber,
                            houseNumberAddition:
                              houseNumberAddition === null
                                ? ""
                                : houseNumberAddition,
                          })
                          .then((res) => {
                            if (
                              typeof res.data !== undefined &&
                              !res.data.data.speed
                            ) {
                              if (
                                defaultSupplier &&
                                defaultSupplier.supplier_id ===
                                  res.data.data.supplier_id
                              ) {
                                vueThis.$store.commit(
                                  "forms/DELETE_OVERVIEW_ELEMENT"
                                );
                              }
                              item.available = 1;
                              if (
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).length == 0
                              ) {
                                vueThis.$store.state.forms.itemIsShow.push({
                                  id: item.supplier_id,
                                  isShow: false,
                                });
                              } else {
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).isShow = false;
                              }
                              // checkSupplier[0].groupDefault = providers.filter(
                              //   x => x.available === 0
                              // )[0].supplier_id;
                            } else {
                              item.available = 0;
                              if (
                                defaultSupplier &&
                                defaultSupplier.supplier_id ===
                                  res.data.data.supplier_id
                              ) {
                                vueThis.setOverview();
                              }
                              if (
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).length == 0
                              ) {
                                vueThis.$store.state.forms.itemIsShow.push({
                                  id: item.supplier_id,
                                  isShow: true,
                                });
                              } else {
                                vueThis.$store.state.forms.itemIsShow.filter(
                                  (a) => a.id == item.supplier_id
                                ).isShow = true;
                              }

                              // let el = "products[internet][supplier_id]"
                              // var a = $(`[name = "${el}"][id="${item.id}"]`)
                            }
                          });
                      }
                    });
                  }
                });
              } else {
                vueThis.arr = [];
                vueThis.listError(res.data.error);

                vueThis.$store.commit("forms/DELETE_OVERVIEW_ELEMENT");
                $("#error").remove();
                $("#housenumber1").remove();
                //$("#city-street-row").removeClass("row");
                $("#number_addition").parent().parent().hide();
                $("#postcode").parent().removeClass("col-sm-4");
                $("#housenumber").parent().removeClass("col-sm-4");
                $("#postcode").parent().addClass("col-sm-6");
                $("#housenumber").parent().addClass("col-sm-6");
                // $("#postcode").addClass("alert-danger");

                vueThis.arr.forEach((m) => {
                  $("#postcode")
                    .parent()
                    .parent()
                    .append(
                      '<div class="col-md-12 " id="error" ><div class="alert alert-danger" role="alert"><p class="mb-0">' +
                        m +
                        "</p></div></div>"
                    );
                });

                $("#street").val("");
                $("#city").val("");

                $("#number_addition").empty();
              }
            });
        }
      });
    }
  },
};
</script>

<style>
.dateinput {
  background-color: transparent !important;
}
#date_of_birth {
  background-color: transparent !important;
}
</style>
